<template>
  <div class="static-text">
    <container v-html=" content && content.content "></container>
  </div>
</template>

<script>
  import {api} from '@/main.js'
  import Container from "@/components/container/index";
  export default {
    name: 'Document',
    components: {Container},
    data () {
      return {
        content: false
      }
    },
    mounted () {
      api.singleton.get('statute').then(response => {
        this.content = JSON.parse(response.data)
        this.content.content = '<h1>Satzung</h1>' + this.content.content;
      })
    }
  }
</script>

<style lang="scss" scoped>
  // see imprint.vue
</style>



// WEBPACK FOOTER //
// src/views/documents/conduct.vue